export const FAQ_CATEGORIES = ['seoQuestions', 'gettingStarted', 'suitability', 'addOnsAndCustomization', 'support', 'securityAndGdpr'] as const
export type FaqCategory = (typeof FAQ_CATEGORIES)[number]
